module.exports = __webpack_public_path__ + "img/sm.5a8d97fc.png";